export interface AdminUserDetails {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
}

export interface AdminUser {
  id: number;
  user: AdminUserDetails;
  isQnaFacilitator?: boolean;
}

interface CustomWidget {
  title: string;
  body: string;
}

export enum AdditionalResourceStatus {
  UPLOADING = 'UPLOADING',
  SUCCESS = 'SUCCESS',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  PROCESSED = 'PROCESSED',
}

export interface AdditionalResource {
  id: number;
  name: string;
  type: string;
  size: number;
  url: string;
  status?: AdditionalResourceStatus;
  uniqueId?: string;
  uploadedFile?: File;
}

export interface IEmbedDataRequest {
  id: number;
  completed?: boolean;
  processedFiles: number[];
  failedFiles?: number[];
}

export enum LearnerFinalSummaryStatus {
  QUEUED = 'queued',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export enum LearnerFinalSummaryErrorCode {
  INSUFFICIENT_CONTENT = 'insufficient_content',
}

export interface LearnerFinalSummary {
  id: number;
  status: LearnerFinalSummaryStatus;
  available: boolean;
  generatedAt: string;
  errorMessage?: string;
  highlightSections?: LearnerFinalSummaryHighlightSection[];
}

export interface LearnerFinalSummaryHighlightSection {
  id: number;
  sectionType: string;
  sectionPayload: {
    title?: string;
    emptyContentI18nKey?: string;
    content?: {
      headline?: string;
      summary?: string;
      [key: string]: unknown;
    };
    [key: string]: unknown;
  };
}

export interface LearnerFinalSummaryDetails extends LearnerFinalSummary {
  reportVersion?: string;
  highlightSections?: LearnerFinalSummaryHighlightSection[];
}

export interface LearnerFinalSummaryUpdatedEventData {
  learnerFinalSummaryReportId: number;
  courseId: number;
  userId?: number;
  userCourseId?: number;
  status: LearnerFinalSummaryStatus;
  available?: boolean;
  generatedAt: string;
  errorMessage?: string;
}

export interface HelpOptions {
  courseAdminUsers?: AdminUser[];
  hasAiLearningAssistantEnabled?: boolean;
  hasPersonalizedTakeawaysEnabled?: boolean;
  hasHelpResourcesEnabled?: boolean;
  courseHelp?: CustomWidget;
  hasAiEmbeddingInProgress?: boolean;
  embedDataRequests?: IEmbedDataRequest[];
  additionalResources?: AdditionalResource[];
  learnerFinalSummary?: LearnerFinalSummary;
  hasAdditionalResourcesChanged?: boolean;
}

export interface HelpOptionsSettingsResponse {
  result: HelpOptions;
  message: string;
}

export interface LearnerFinalSummaryDetailsResponse {
  result: LearnerFinalSummaryDetails;
  message: string;
}


export interface IHelpOptionsSettingsPayload {
  userCourseIds: number[];
  hasAiLearningAssistantEnabled: boolean;
  hasHelpResourcesEnabled: boolean;
  courseHelp: {
    title: string;
    body: string;
  };
  additionalResourceIds?: number[];
}
